import { createSlice } from "@reduxjs/toolkit";

const initialEvaluationState = {
  page: null,
  limit: null,
  totalPages: null,
  evaluations: [],
  listLoading: false,
  totalResults: null,
  actionLoading: false,
  selectedEvaluation: null,
};

export const EvaluationSlice = createSlice({
  name: "EvaluationSlice",
  initialState: initialEvaluationState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getEvaluations: (state, action) => {
      const { page, limit, results, totalPages, totalResults } = action?.payload?.evaluation;
      state.evaluations = results;
      state.page = page;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.listLoading = false;
    },
    getSelectedEvaluation: (state, action) => {
      state.selectedEvaluation = action?.payload?.evaluation;
      state.listLoading = false;
    },
  },
});
